import React from 'react';
import Button from '@material-ui/core/Button';
import classnames from 'classnames';


import styles from './SimpleButton.scss';
import mergeStyles from 'components/helpers/mergeStyles';

export default function SimpleButton(props) {
    const {className, children, classes, ...restProps} = props;

    return (
        <Button
            classes={
                mergeStyles(
                    classes,
                    {
                        root: classnames(styles.root, className),
                        label: styles.label,
                    }
                )
            }
            {...restProps}
        >
            {children || ''}
        </Button>
    );
}



// WEBPACK FOOTER //
// ./src/components/controls/buttons/SimpleButton.jsx